<template>
  <div>
    <basic-container>
      <div>
        <el-form ref="form" :model="dynamicForm">
          <!-- 表单名称 -->
          <el-form-item label="表单名称" style="display: flex;width:300px;">
            <el-input v-model="dynamicForm.formName" placeholder="请输入表单名称"></el-input>
          </el-form-item>

          <!-- 表单类型 -->
          <el-form-item label="表单类型" style="display: flex;width:300px;">
            <el-select v-model="dynamicForm.formType" placeholder="请选择表单类型" clearable @change="selectFormType">
              <el-option v-for="item in dynamicTypes" :key="item.id" :label="item.typeName" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>

          <!-- 动态表单 -->
          <el-form-item label="动态表单">
            <el-table :data="dynamicFormData" border style="width: 100%; margin-top: 20px">
              <el-table-column prop="fieldName" label="显示名称" min-width="150">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.fieldName" placeholder="请输入名称"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="inputType" label="控件类型" min-width="150">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.inputType" placeholder="请选择控件类型" clearable>
                    <el-option v-for="inputType in inputTypes" :key="inputType.id" :label="inputType.name"
                      :value="inputType.id">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column prop="dataSource" label="数据源" min-width="150">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.dataSource" placeholder="请选择数据源" clearable>
                    <el-option v-for="dataSource in dataSources" :key="dataSource.id" :label="dataSource.valueName"
                      :value="dataSource.id">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <!-- 是否展示showFlag -->
              <el-table-column prop="showFlag" label="是否展示" min-width="150">
                <template slot-scope="scope">
                  <el-radio-group v-model="scope.row.showFlag">
                    <el-radio label="YES">是</el-radio>
                    <el-radio label="NO">否</el-radio>
                  </el-radio-group>
                </template>
              </el-table-column>
              <!-- 下拉多选客户端showClients -->
              <el-table-column prop="showClient" label="客户端" min-width="150">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.showClient" placeholder="请选择客户端" clearable multiple>
                    <el-option v-for="client in typeClients" :key="client.value" :label="client.label"
                      :value="client.value"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column prop="isNull" label="是否为空" width="150">
                <template slot-scope="scope">
                  <el-radio-group v-model="scope.row.isNull">
                    <el-radio label="YES">是</el-radio>
                    <el-radio label="NO">否</el-radio>
                  </el-radio-group>
                </template>
              </el-table-column>
              <!-- 是否计费 -->
              <el-table-column prop="charging" label="是否计费" width="150">
                <template slot-scope="scope">
                  <el-radio-group v-model="scope.row.charging">
                    <el-radio label="YES">是</el-radio>
                    <el-radio label="NO">否</el-radio>
                  </el-radio-group>
                </template>
              </el-table-column>
              <!-- 选择计费表 -->
              <el-table-column prop="chargingId" label="选择计费表" width="150">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.chargingId" placeholder="请选择计费表" clearable>
                    <el-option v-for="billingRule in billingRules" :key="billingRule.id" :label="billingRule.name"
                      :value="billingRule.id">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column prop="engineerFee" label="工程师费用" min-width="120">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.engineerFee" placeholder="请输入工程师费用" type="number" min="0"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="merchantFee" label="商户费用" min-width="120">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.merchantFee" placeholder="请输入商户费用" type="number" min="0"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="threshold" label="费用起征点" min-width="120">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.threshold" placeholder="请输入起征点" type="number" min="0"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="chargeWithinThreshold" label="不足时按起征点收费" width="150">
                <template slot-scope="scope">
                  <el-radio-group v-model="scope.row.chargeWithinThreshold">
                    <el-radio label="YES">是</el-radio>
                    <el-radio label="NO">否</el-radio>
                  </el-radio-group>
                </template>
              </el-table-column>
              <el-table-column prop="chargeOutsideThreshold" label="起征点外收费" width="150">
                <template slot-scope="scope">
                  <el-radio-group v-model="scope.row.chargeOutsideThreshold">
                    <el-radio label="YES">是</el-radio>
                    <el-radio label="NO">否</el-radio>
                  </el-radio-group>
                </template>
              </el-table-column>
              <!-- 排序 -->
              <el-table-column prop="sort" label="排序" width="150">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.sort"></el-input>
                </template>
              </el-table-column>
              <el-table-column align="center" label="操作" width="150">
                <template slot-scope="scope">
                  <el-button type="danger" icon="el-icon-close" size="small"
                    @click="handleSteppingDelete(scope.$index)">删除</el-button>
                </template>
              </el-table-column>
              <el-table-column align="center" label="配置" width="150">
                <template slot-scope="scope">
                  <el-button type="warning" icon="el-icon-plus" size="small"
                    @click="handleAddRows(scope.$index)">增加一行</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
        </el-form>
      </div>
      <div style="width:100%;display:flex;flex-flow:row nowrap;justify-content: center;margin-top:20px">
        <el-button type="primary" size="small" @click="submit">确定新增</el-button>
      </div>
    </basic-container>
  </div>
</template>



<script>
import { DIC } from "@/const/dic";
import { getDynamicType } from "@/api/work/formType";
import {
  findDataSourceFields,
  findDataSourceAll,
  addDynamic,
  findBillingRule
} from "@/api/work/dynamicForm";

export default {
  data() {
    return {
      categoryTypes: [],
      qd: [1, 2],
      isPas: false,
      inputTypes: [],
      dataSources: [],
      agentIds: [],
      auditors: DIC.SERVICEITEM_AUDITOR,
      clientTypes: DIC.SERVICEITEM_TYPE,
      billingRules: [],
      dynamicForm: {
        formName: '',
        formType: ''
      },
      typeClients: [
        {
          label: "工程师端",
          value: "JOINS_ENGINEER",
        },
        {
          label: "消费者端",
          value: "JOINS_USER",
        },
        {
          label: "商户端",
          value: "JOINS_MERCHANT",
        }
      ],
      dynamicTypes: [], // 确保这是一个数组
      dynamicFormData: [] // 确保这是一个数组
    };
  },
  created() {
    findDataSourceFields().then(res => {
      let data = JSON.parse(res.data);
      this.inputTypes = data;
    });
    findDataSourceAll().then(res => {
      let data = JSON.parse(res.data);
      this.dataSources = data.rows;
    });
    findBillingRule().then(res => {
      let data = JSON.parse(res.data);
      this.billingRules = data.rows;
      console.log('this.billingRules', this.billingRules);

    })
    getDynamicType().then(res => {
      let data = JSON.parse(res.data).rows;
      this.dynamicTypes = data;
    });
  },
  methods: {
    selectFormType(formType) {
      this.dynamicForm.formType = formType;
      // 初始化dynamicFormData
      this.dynamicFormData = [{
        fieldName: '',
        inputType: '',
        dataSource: '',
        showFlag: '',
        showClient: [],
        isNull: '',
        charging: '',
        chargingId: '',
        engineerFee: '',
        merchantFee: '',
        threshold: '',
        chargeWithinThreshold: '',
        chargeOutsideThreshold: '',
        sort: ''
      }];
    },
    submit() {
      // 构建提交的数据结构
      const submitData = {
        name: this.dynamicForm.formName,
        targetType: this.dynamicTypes.find(type => type.id === this.dynamicForm.formType).typeCode,
        fields: this.dynamicFormData.map(field => ({
          fieldName: field.fieldName,
          inputType: field.inputType,
          dataSource: field.dataSource,
          charging: field.charging,
          chargingId: field.chargingId,
          sort: field.sort,
          isNull: field.isNull,
          showFlag: field.showFlag,
          showClient: field.showClient.join(',') // 将数组转换为逗号分隔的字符串
        }))
      };
      /* // 校验表单，如果选择了计费表但未选择计费规则，则提示错误
      if (submitData.fields.some(field => field.charging === 'YES' && !field.chargingId)) {
        this.$message({
          showClose: true,
          message: "请选择是否计费",
          type: "error"
        });
        return;
      } */
      console.log('提交的数据：', submitData);

      addDynamic(submitData).then(res => {
        if (res.code == "200") {
          this.$message({
            showClose: true,
            message: "新增成功",
            type: "success"
          });
          // 返回上一页
          this.$router.go(-1);
        } else {
          if (!this.isPas) {
            this.$message({
              showClose: true,
              message: res.message,
              type: "error"
            });
            this.isPas = true;
            setTimeout(() => {
              this.isPas = false;
            }, 1000);
          }
        }
      });
    },
    handleSteppingDelete(index) {
      if (this.dynamicFormData.length == 1) {
        this.$message({
          showClose: true,
          message: "动态表单不能为空",
          type: "error"
        });
      } else {
        this.dynamicFormData.splice(index, 1);
      }
    },
    handleAddRows() {
      this.dynamicFormData.push({
        fieldName: '',
        inputType: '',
        dataSource: '',
        charging: '',
        chargingId: '',
        isNull: '',
        sort: ''
      });
    }
  }
};
</script>

<style></style>